module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB4003-86f018451aa47b0f890917842b8e72e2.png";